// frontend/src/components/ui/error-boundary.jsx
import React from 'react';
import { Card } from './card';
import { Button } from './button';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const FallbackComponent = this.props.FallbackComponent || DefaultErrorFallback;
      return <FallbackComponent error={this.state.error} />;
    }

    return this.props.children;
  }
}

function DefaultErrorFallback({ error }) {
  return (
    <Card className="p-6">
      <div className="flex items-start space-x-3">
        <ExclamationTriangleIcon className="h-6 w-6 text-red-500 mt-0.5" />
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-foreground">Something went wrong</h2>
          <p className="text-sm text-muted-foreground mt-1">
            We couldn't load this section. Try again or contact support.
          </p>
          {process.env.NODE_ENV === 'development' && error && (
            <details className="mt-3">
              <summary className="text-xs text-muted-foreground cursor-pointer">
                Error details (development only)
              </summary>
              <pre className="text-xs text-red-600 dark:text-red-400 mt-2 p-2 bg-red-50 dark:bg-red-950/10 rounded overflow-auto">
                {error.toString()}
              </pre>
            </details>
          )}
          <div className="mt-3">
            <Button onClick={() => window.location.reload()}>
              Retry
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
}




